import tw, { styled } from 'twin.macro';

import { Props } from './Link';

export const StyledLink = styled.a<Props>(({ inheritSize }) => [
	tw`text-indigo-500 underline`,
	!inheritSize && tw`text-sm`,
]);
